import styled, { css } from 'styled-components'

import Text from '~/components/Text'

import { HeightClass } from '~/utils/enum/classes'

import { Direction, Position } from './enum'

export const Label = styled(Text).attrs({ as: 'label' })<{
  heightClass: HeightClass
  isBeforePositioned: boolean
  optionLabelsPosition: Position
  direction: Direction
}>`
  color: #303032;

  ${({ theme, heightClass, direction, isBeforePositioned }) => {
    if (direction === 'horizontal' && !isBeforePositioned) {
      return `
        padding-top: ${(theme.explicitSelectionButton[heightClass]?.generalLabelPadding || 0) + 4}px;
        padding-bottom: 0;
      `
    } else {
      return `
        padding-bottom: ${theme.explicitSelectionButton[heightClass]?.generalLabelPadding}px;
        padding-top: 0;
      `
    }
  }}

  ${({ isBeforePositioned }) => (isBeforePositioned ? 'align-self: end;' : '')}

  ${({ theme, heightClass, direction }) => {
    const marginValue = theme.explicitSelectionButton[heightClass]?.spaceBetween

    if (direction === 'horizontal') {
      return `margin-right: ${marginValue}px;`
    }
  }}

  ${({ optionLabelsPosition }) =>
    optionLabelsPosition === 'alternating'
      ? 'align-self: center; padding-top: 0;'
      : ''}

  [aria-required=true] & {
    font-weight: 700;
  }
`
export const OptionLabel = styled(Text).attrs({ as: 'label' })<{
  heightClass: HeightClass
  show: boolean
  isBeforePositioned: boolean
  direction: Direction
}>`
  width: 100%;
  color: #303032;

  ${({ theme, heightClass, isBeforePositioned }) => {
    const marginValue = theme.explicitSelectionButton[heightClass]?.spaceBetween

    return isBeforePositioned
      ? `margin-bottom: ${marginValue}px;`
      : `margin-top: ${marginValue}px;`
  }}

  ${({ direction, isBeforePositioned }) => {
    if (direction === 'horizontal') {
      return ''
    }

    return `margin: 0; ${
      isBeforePositioned ? 'text-align: right;' : 'text-align: left;'
    }`
  }}

  visibility: ${({ show }) => (show ? 'visible' : 'hidden')}
`

export const OptionContainer = styled.div<{
  heightClass: HeightClass
  direction: Direction
}>`
  display: inline-flex;
  text-align: center;
  align-items: center;

  margin-right: ${({ theme, heightClass }) =>
    theme.explicitSelectionButton[heightClass]?.spaceBetween}px;

  ${({ theme, heightClass, direction }) =>
    direction === 'horizontal'
      ? 'flex-direction: column;'
      : css`
          flex-direction: row;
          gap: ${theme.explicitSelectionButton[heightClass]?.spaceBetween}px;
          width: 100%;
          margin-bottom: ${theme.explicitSelectionButton[heightClass]
            ?.spaceBetween}px;
        `}
`

export const ComponentStructure = styled.div<{ direction: Direction }>`
  display: flex;

  ${({ direction }) =>
    direction === 'vertical'
      ? `
        flex-direction: column;
        align-items: flex-start;
      `
      : ''}

  font-weight: 400;
`

export const OptionBorder = styled.div<{
  heightClass: HeightClass
  nonFocusable: boolean
  disabled: boolean
}>`
  width: ${({ theme, heightClass = 'regular' }) =>
    (theme.explicitSelectionButton[heightClass]?.width || 0) + 8}px;

  height: ${({ theme, heightClass = 'regular' }) =>
    (theme.explicitSelectionButton[heightClass]?.height || 0) + 8}px;

  padding: 1px;
  display: grid;
  place-items: center;

  ${({ theme, nonFocusable, heightClass, disabled }) =>
    !nonFocusable
      ? `
        border: 3px solid transparent;
        border-radius: 50%;

        ${
          !disabled
            ? `
              &:active {
                border-color: #ABBED1;
              }

              &:not(:active) {
                transition: border-color 1s ease-out;
              }
            `
            : 'cursor: not-allowed;'
        }
      `
      : `
        border-width: ${theme.explicitSelectionButton[heightClass]?.borderSize || 0}px;
        border-style: solid;
        border-color: #006bff;
      `}
`
